export default "__VITE_ASSET__Cp$9UTiD__"